export default "* Tør bark \n* Pinde\n* Fjer/Blade\n* Håndbor\n* Lange græsstrå eller bast-snor";